// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GlobalPlanTaskSelectQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalPlanTaskFilter>;
}>;


export type GlobalPlanTaskSelectQuery = { __typename?: 'Query', globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', id: string, name: string }> } };


export const GlobalPlanTaskSelectDocument = gql`
    query GlobalPlanTaskSelect($filter: GlobalPlanTaskFilter) {
  globalPlanTasks(filter: $filter) {
    entities {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useGlobalPlanTaskSelectQuery__
 *
 * To run a query within a React component, call `useGlobalPlanTaskSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalPlanTaskSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalPlanTaskSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGlobalPlanTaskSelectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalPlanTaskSelectQuery, GlobalPlanTaskSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalPlanTaskSelectQuery, GlobalPlanTaskSelectQueryVariables>(GlobalPlanTaskSelectDocument, options);
      }
export function useGlobalPlanTaskSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalPlanTaskSelectQuery, GlobalPlanTaskSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalPlanTaskSelectQuery, GlobalPlanTaskSelectQueryVariables>(GlobalPlanTaskSelectDocument, options);
        }
export function useGlobalPlanTaskSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalPlanTaskSelectQuery, GlobalPlanTaskSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalPlanTaskSelectQuery, GlobalPlanTaskSelectQueryVariables>(GlobalPlanTaskSelectDocument, options);
        }
export type GlobalPlanTaskSelectQueryHookResult = ReturnType<typeof useGlobalPlanTaskSelectQuery>;
export type GlobalPlanTaskSelectLazyQueryHookResult = ReturnType<typeof useGlobalPlanTaskSelectLazyQuery>;
export type GlobalPlanTaskSelectSuspenseQueryHookResult = ReturnType<typeof useGlobalPlanTaskSelectSuspenseQuery>;
export type GlobalPlanTaskSelectQueryResult = Apollo.QueryResult<GlobalPlanTaskSelectQuery, GlobalPlanTaskSelectQueryVariables>;